var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "product-list-page",
      class: { "page-drag-over": _vm.isPageDraggingOver },
      on: {
        dragenter: function ($event) {
          $event.preventDefault()
          return _vm.handlePageDragEnter.apply(null, arguments)
        },
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.handlePageDragOver.apply(null, arguments)
        },
        dragleave: function ($event) {
          $event.preventDefault()
          return _vm.handlePageDragLeave.apply(null, arguments)
        },
        drop: function ($event) {
          $event.preventDefault()
          return _vm.handlePageDrop.apply(null, arguments)
        },
      },
    },
    [
      _vm.isPageDraggingOver
        ? _c("div", { staticClass: "page-drop-overlay" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "product-id-list-form-group",
                      attrs: { label: "List Name", "label-for": "name" },
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "product-id-list-name-input",
                        attrs: {
                          id: "name",
                          type: "text",
                          placeholder: "Enter list name",
                          required: "",
                        },
                        model: {
                          value: _vm.formData.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "name", $$v)
                          },
                          expression: "formData.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center mb-3",
                  },
                  [
                    _c("h5", { staticClass: "product-id-list-section-title" }, [
                      _vm._v("\n            Product Records\n          "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "product-id-list-import-btn",
                            attrs: { variant: "outline-secondary" },
                            on: { click: _vm.showImportModal },
                          },
                          [
                            _c("i", { staticClass: "fas fa-upload mr-2" }),
                            _vm._v(
                              "\n              Import from Spreadsheet\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-dropdown",
                          {
                            staticClass: "ml-2 product-id-list-add-dropdown",
                            attrs: {
                              variant: "success",
                              text: "Add Products",
                              right: "",
                            },
                          },
                          [
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.addNewRecord(1)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Add Product\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              { on: { click: _vm.addMultipleIdentifiers } },
                              [
                                _vm._v(
                                  "\n                Add Multiple...\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "table-responsive product-id-list-table-wrapper",
                  },
                  [
                    _c(
                      "table",
                      { staticClass: "table product-id-list-table" },
                      [
                        _c(
                          "thead",
                          { staticClass: "product-id-list-table-head" },
                          [
                            _c("tr", [
                              _c(
                                "th",
                                { staticClass: "product-id-list-table-th" },
                                [
                                  _vm._v(
                                    "\n                  Row #\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticClass: "product-id-list-table-th" },
                                [
                                  _vm._v(
                                    "\n                  Material Code\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticClass: "product-id-list-table-th" },
                                [
                                  _vm._v(
                                    "\n                  GTIN\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticClass: "product-id-list-table-th" },
                                [
                                  _vm._v(
                                    "\n                  ASIN\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticClass: "product-id-list-table-th" },
                                [
                                  _vm._v(
                                    "\n                  TCIN\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticClass: "product-id-list-table-th" },
                                [
                                  _vm._v(
                                    "\n                  Walmart ID\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticClass: "product-id-list-table-th" },
                                [
                                  _vm._v(
                                    "\n                  Salsify ID\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticClass: "product-id-list-table-th" },
                                [
                                  _vm._v(
                                    "\n                  URL\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticClass: "product-id-list-table-th" },
                                [
                                  _vm._v(
                                    "\n                  Brand\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticClass: "product-id-list-table-th" },
                                [
                                  _vm._v(
                                    "\n                  Product Name\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticClass: "product-id-list-table-th" },
                                [
                                  _vm._v(
                                    "\n                  Actions\n                "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm._l(
                              _vm.productRecords,
                              function (record, index) {
                                return _c(
                                  "tr",
                                  {
                                    key: index,
                                    staticClass: "product-id-list-table-row",
                                  },
                                  [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "product-id-list-table-td",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(index + 1) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "product-id-list-table-td",
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "product-id-list-input",
                                          attrs: {
                                            size: "sm",
                                            placeholder: "Material Code",
                                          },
                                          model: {
                                            value: record.material_code,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                record,
                                                "material_code",
                                                $$v
                                              )
                                            },
                                            expression: "record.material_code",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "product-id-list-table-td",
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "product-id-list-input",
                                          attrs: {
                                            size: "sm",
                                            placeholder: "GTIN",
                                          },
                                          model: {
                                            value: record.gtin,
                                            callback: function ($$v) {
                                              _vm.$set(record, "gtin", $$v)
                                            },
                                            expression: "record.gtin",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "product-id-list-table-td",
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "product-id-list-input",
                                          attrs: {
                                            size: "sm",
                                            placeholder: "ASIN",
                                          },
                                          model: {
                                            value: record.asin,
                                            callback: function ($$v) {
                                              _vm.$set(record, "asin", $$v)
                                            },
                                            expression: "record.asin",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "product-id-list-table-td",
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "product-id-list-input",
                                          attrs: {
                                            size: "sm",
                                            placeholder: "TCIN",
                                          },
                                          model: {
                                            value: record.tcin,
                                            callback: function ($$v) {
                                              _vm.$set(record, "tcin", $$v)
                                            },
                                            expression: "record.tcin",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "product-id-list-table-td",
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "product-id-list-input",
                                          attrs: {
                                            size: "sm",
                                            placeholder: "Walmart ID",
                                          },
                                          model: {
                                            value: record.walmart_id,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                record,
                                                "walmart_id",
                                                $$v
                                              )
                                            },
                                            expression: "record.walmart_id",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "product-id-list-table-td",
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "product-id-list-input",
                                          attrs: {
                                            size: "sm",
                                            placeholder: "Salsify ID",
                                          },
                                          model: {
                                            value: record.salsify_id,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                record,
                                                "salsify_id",
                                                $$v
                                              )
                                            },
                                            expression: "record.salsify_id",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "product-id-list-table-td",
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "product-id-list-input",
                                          attrs: {
                                            size: "sm",
                                            placeholder: "URL",
                                          },
                                          model: {
                                            value: record.url,
                                            callback: function ($$v) {
                                              _vm.$set(record, "url", $$v)
                                            },
                                            expression: "record.url",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "product-id-list-table-td",
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "product-id-list-input",
                                          attrs: {
                                            size: "sm",
                                            placeholder: "Brand",
                                          },
                                          model: {
                                            value: record.brand,
                                            callback: function ($$v) {
                                              _vm.$set(record, "brand", $$v)
                                            },
                                            expression: "record.brand",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "product-id-list-table-td",
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "product-id-list-input",
                                          attrs: {
                                            size: "sm",
                                            placeholder: "Product Name",
                                          },
                                          model: {
                                            value: record.product_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                record,
                                                "product_name",
                                                $$v
                                              )
                                            },
                                            expression: "record.product_name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "product-id-list-table-td",
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "product-id-list-delete-btn",
                                            attrs: {
                                              variant: "danger",
                                              size: "sm",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeRecord(index)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "far fa-trash-alt",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            ),
                            _vm._v(" "),
                            _vm.productRecords.length === 0
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "product-id-list-empty-state-td",
                                      attrs: { colspan: "11" },
                                    },
                                    [
                                      _vm._v(
                                        '\n                  No records added yet. Click "Add Product" to get started.\n                '
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-end product-id-list-footer-actions",
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-2 product-id-list-cancel-btn",
                        attrs: { variant: "outline-secondary" },
                        on: { click: _vm.handleCancel },
                      },
                      [_vm._v("\n            Cancel\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "product-id-list-save-btn",
                        attrs: {
                          variant: "success",
                          disabled: _vm.isSubmitting,
                        },
                        on: { click: _vm.handleSubmit },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.isSubmitting ? "Saving..." : "Save List"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "importModal",
          attrs: {
            id: "import-modal",
            title: "Import Products from Spreadsheet",
            size: "lg",
            "body-class": "p-0",
            "footer-class": "p-0",
            "hide-footer": "",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "drop-zone-wrapper",
              class: { "drag-over": _vm.isDraggingOver },
              on: {
                dragenter: function ($event) {
                  $event.preventDefault()
                  return _vm.handleDragEnter.apply(null, arguments)
                },
                dragover: function ($event) {
                  $event.preventDefault()
                  return _vm.handleDragOver.apply(null, arguments)
                },
                dragleave: function ($event) {
                  $event.preventDefault()
                  return _vm.handleDragLeave.apply(null, arguments)
                },
                drop: function ($event) {
                  $event.preventDefault()
                  return _vm.handleDrop.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "modal-body-content" },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.handleImport.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Select Spreadsheet file" } },
                        [
                          _c("b-form-file", {
                            attrs: {
                              accept: ".xlsx,.xls,.csv",
                              placeholder: "Choose file or drop it here...",
                              "drop-placeholder": "Drop file here...",
                            },
                            on: { input: _vm.onFileInput },
                            model: {
                              value: _vm.importFile,
                              callback: function ($$v) {
                                _vm.importFile = $$v
                              },
                              expression: "importFile",
                            },
                          }),
                          _vm._v(" "),
                          _c("small", { staticClass: "form-text text-muted" }, [
                            _vm._v(
                              "\n              Need a template?\n              "
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "text-primary",
                                attrs: {
                                  href: "/product-id-list/import-template",
                                  download: "",
                                },
                              },
                              [
                                _c("i", { staticClass: "fas fa-download" }),
                                _vm._v(
                                  " Download sample spreadsheet\n              "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.importFile
                        ? _c("div", { staticClass: "mt-3" }, [
                            _c("p", { staticClass: "text-muted" }, [
                              _c("strong", [_vm._v("Selected file:")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.importFile.name) +
                                  "\n            "
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.fileSheets.length > 0
                        ? _c(
                            "div",
                            { staticClass: "mt-3" },
                            [
                              _c("p", {}, [_c("strong", [_vm._v("Sheets:")])]),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                [
                                  _c(
                                    "b-form-checkbox-group",
                                    {
                                      model: {
                                        value: _vm.selectedSheets,
                                        callback: function ($$v) {
                                          _vm.selectedSheets = $$v
                                        },
                                        expression: "selectedSheets",
                                      },
                                    },
                                    _vm._l(_vm.fileSheets, function (sheet) {
                                      return _c(
                                        "b-form-checkbox",
                                        { key: sheet, attrs: { value: sheet } },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(sheet) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedSheets.length > 0
                        ? _c(
                            "div",
                            { staticClass: "mt-3 column-mapping-wrapper" },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName:
                                        "v-b-toggle.import-column-mapping",
                                      modifiers: {
                                        "import-column-mapping": true,
                                      },
                                    },
                                  ],
                                  staticClass: "p-0 column-mapping-toggle",
                                  attrs: { variant: "link" },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-random mr-1",
                                  }),
                                  _vm._v(
                                    "\n              Column mapping\n              "
                                  ),
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-collapse",
                                {
                                  staticClass: "mt-3",
                                  attrs: { id: "import-column-mapping" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "column-mapping-panel" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "text-muted small mb-3",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Match spreadsheet columns to Product ID List fields.\n                  Suggested mappings are selected automatically.\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.selectedSheets,
                                        function (sheetName) {
                                          return _c(
                                            "div",
                                            {
                                              key: sheetName,
                                              staticClass:
                                                "column-mapping-sheet",
                                            },
                                            [
                                              _vm.selectedSheets.length > 1
                                                ? _c(
                                                    "h6",
                                                    { staticClass: "mb-3" },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(sheetName) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.columnMappings[sheetName]
                                                ? _vm._l(
                                                    _vm.importMappingFields,
                                                    function (field) {
                                                      return _c(
                                                        "b-form-group",
                                                        {
                                                          key:
                                                            sheetName +
                                                            "-" +
                                                            field.key,
                                                          staticClass: "mb-2",
                                                          attrs: {
                                                            label: field.label,
                                                            "label-cols-md":
                                                              "4",
                                                            "label-align-md":
                                                              "right",
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-select", {
                                                            attrs: {
                                                              options:
                                                                _vm.getColumnOptions(
                                                                  sheetName
                                                                ),
                                                              size: "sm",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .columnMappings[
                                                                  sheetName
                                                                ][field.key],
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .columnMappings[
                                                                      sheetName
                                                                    ],
                                                                    field.key,
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "columnMappings[sheetName][field.key]",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  )
                                                : _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "text-muted small",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    No columns found in this sheet.\n                  "
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            2
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "drop-zone-footer" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: { click: _vm.cancelImport },
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", disabled: !_vm.importFile },
                      on: { click: _vm.handleImport },
                    },
                    [_vm._v("\n          Import Products\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isDraggingOver
                ? _c("div", { staticClass: "drop-zone-overlay" }, [
                    _c("div", { staticClass: "drop-zone-message" }, [
                      _c("i", { staticClass: "fas fa-file-upload fa-3x mb-3" }),
                      _vm._v(" "),
                      _c("h4", [_vm._v("Drop spreadsheet file here")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-muted" }, [
                        _vm._v(
                          "\n            Supports .xlsx, .xls, and .csv files\n          "
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "addMultipleIdentifiersModal",
          attrs: {
            id: "add-multiple-identifiers-modal",
            title: "Add Multiple Product Identifiers",
            size: "lg",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-between w-100" },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "secondary" },
                              on: { click: _vm.cancelAddMultipleIdentifiers },
                            },
                            [_vm._v("\n            Cancel\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "ml-2 mb-0",
                              model: {
                                value: _vm.addGtinsAsSalsifyIds,
                                callback: function ($$v) {
                                  _vm.addGtinsAsSalsifyIds = $$v
                                },
                                expression: "addGtinsAsSalsifyIds",
                              },
                            },
                            [
                              _c("span", { staticClass: "small" }, [
                                _vm._v(
                                  "\n              Add GTINs as Salsify IDs\n            "
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "success",
                            disabled: _vm.identifiersPreview.length === 0,
                          },
                          on: { click: _vm.confirmAddMultipleIdentifiers },
                        },
                        [
                          _vm._v(
                            "\n          Add " +
                              _vm._s(_vm.identifiersPreview.length) +
                              " Record" +
                              _vm._s(
                                _vm.identifiersPreview.length !== 1 ? "s" : ""
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.confirmAddMultipleIdentifiers.apply(
                    null,
                    arguments
                  )
                },
              },
            },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label:
                      "Paste each product identifier on a new line (e.g. URL, ASIN, GTIN, etc.):",
                    "label-for": "identifiersText",
                  },
                },
                [
                  _c("b-form-textarea", {
                    attrs: {
                      id: "identifiersText",
                      rows: "10",
                      placeholder:
                        "Enter each product identifier on a new line, separated by line breaks...",
                    },
                    on: { input: _vm.updateIdentifiersPreview },
                    model: {
                      value: _vm.identifiersText,
                      callback: function ($$v) {
                        _vm.identifiersText = $$v
                      },
                      expression: "identifiersText",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.identifiersPreview.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "mt-3 border rounded p-2",
                      staticStyle: {
                        "max-height": "340px",
                        "overflow-y": "auto",
                      },
                    },
                    [
                      _c("p", { staticClass: "text-success mb-2" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.identifiersPreview.length) +
                              " identifiers detected:"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "list-unstyled mb-0" },
                        _vm._l(_vm.identifiersPreview, function (item, index) {
                          return _c("li", { key: index, staticClass: "mb-1" }, [
                            _c(
                              "span",
                              { staticClass: "badge badge-primary mr-2" },
                              [_vm._v(_vm._s(item.type.toUpperCase()))]
                            ),
                            _vm._v(" "),
                            _c("code", [_vm._v(_vm._s(item.value))]),
                          ])
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.identifiersErrors.length > 0
                ? _c("div", { staticClass: "mt-3" }, [
                    _c("p", { staticClass: "text-warning mb-2" }, [
                      _c("strong", [_vm._v("Unrecognized formats:")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "list-unstyled mb-0" },
                      _vm._l(_vm.identifiersErrors, function (error, index) {
                        return _c(
                          "li",
                          { key: index, staticClass: "mb-1 text-muted" },
                          [_c("code", [_vm._v(_vm._s(error))])]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page-drop-message" }, [
      _c("i", { staticClass: "fas fa-file-upload fa-4x mb-3" }),
      _vm._v(" "),
      _c("h3", [_vm._v("Drop spreadsheet file here")]),
      _vm._v(" "),
      _c("p", { staticClass: "text-muted" }, [
        _vm._v("\n        Supports .xlsx, .xls, and .csv files\n      "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }